<template>
    <div>
        <h1 class="display-heading">Doctor Approval</h1>

        <div class="card mb-3">
            <div class="card-header">Approval Status</div>
            <div class="card-body">
                <div class="row mb-3">
                    <div class="col-md-3"><b>Review Status</b></div>
                    <div class="col-md-9">
                        <span class="badge text-nowrap" :class="{
                                    'badge-success': isReviewed,
                                    'badge-secondary': !isReviewed,
                                }">
                            {{isReviewed ? 'Reviewed' : 'Not Review Yet'}}
                        </span>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-3"><b>Approval Status</b></div>
                    <div class="col-md-9">
                        <template v-if="isReviewed">
                            <span class="badge text-nowrap" :class="{
                                        'badge-success': isApproved && !isDisapproved,
                                        'badge-danger': isDisapproved,
                                    }">
                                {{(isApproved && !isDisapproved) ? 'Approved' : 'Disapproved'}}
                            </span>
                        </template>
                        <template v-else>
                            <span class="badge badge-secondary text-nowrap">
                                Not Review Yet
                            </span>
                        </template>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3"><b>Update Approval</b></div>
                    <div class="col-md-9">
                        <button class="btn btn-primary btn-primary-insv mr-2" @click="updateApproval(true)">Approve</button>
                        <button class="btn btn-primary btn-danger mr-2" @click="updateApproval(false)">Reject</button>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <table class="table table-bordered table-sm">
                <colgroup>
                    <col width="250">
                    <col>
                </colgroup>
                <tr>
                    <th colspan="2" class="text-uppercase">General Info</th>
                </tr>
                <tr>
                    <th>Join Date</th>
                    <td>{{userProfile.joinedDate}}</td>
                </tr>
                <tr>
                    <th>Full Name</th>
                    <td>{{userProfile.name}}</td>
                </tr>
                <tr>
                    <th>Profile Picture</th>
                    <td>
                        <div class="doctor-profile">
                            <div v-if="!profilePhoto.pictureUrl" class="no-photo">No Photo</div>
                            <img v-else :src="`//${profilePhoto.pictureUrl}`">
                        </div>
                    </td>
                </tr>
                <tr>
                    <th>Identification Type</th>
                    <td>{{userProfile.identitifcationType}}</td>
                </tr>
                <tr>
                    <th>Identification Number</th>
                    <td>{{userProfile.identificationNumber}}</td>
                </tr>
                <tr>
                    <th>Email Address</th>
                    <td>{{userProfile.email}}</td>
                </tr>
                <tr>
                    <th>Phone Number</th>
                    <td>{{userProfile.phoneNo}}</td>
                </tr>
                <tr>
                    <th>Languages Speak</th>
                    <td>{{doctorProfile.languagesSpeak}}</td>
                </tr>
            </table>

            <table class="table table-bordered table-sm">
                <colgroup>
                    <col width="250">
                    <col>
                </colgroup>
                <tr>
                    <th colspan="2" class="text-uppercase">Profession and Qualifications</th>
                </tr>
                <tr>
                    <th>Education</th>
                    <td>
                        {{ doctorProfile.education }}

                    </td>
                </tr>
                <tr>
                    <th>Specialties</th>
                    <td>
                        {{ doctorSpecialties }}
                    </td>
                </tr>
                <tr>
                    <th>Hospital or Clinic Affiliation</th>
                    <td>
                        {{ doctorProfile.affiliation }}
                    </td>
                </tr>
                <tr>
                    <th>Work Location Area</th>
                    <td>
                        {{ doctorProfile.location }}
                    </td>
                </tr>
                <tr>
                    <th>Years Practicing</th>
                    <td>
                        {{ doctorProfile.yearsPracticing }}
                    </td>
                </tr>
            </table>

            <table class="table table-bordered table-sm">
                <colgroup>
                    <col width="250">
                    <col>
                </colgroup>
                <tr>
                    <th colspan="2" class="text-uppercase">Documents / Legal Details</th>
                </tr>

                <tr>
                    <th>MMC Number</th>
                    <td>
                        {{ doctorProfile.registrationNumber ? doctorProfile.registrationNumber : '-' }}
                    </td>
                </tr>
                <tr>
                    <th>MMC Document</th>
                    <td>
                        <div v-if="!!mmcUpload.docFileNameGUID">
                            <div>
                                <a :href="`${doctorDocumentPath}${mmcUpload.docFileNameGUID}`" class="btn btn-primary btn-primary-insv" target="_blank">Download Document</a>
                            </div>
                        </div>
                        <div v-else class="font-italic">Not Uploaded</div>
                    </td>
                </tr>
                <tr>
                    <th>Annual Practitioner Certificate</th>
                    <td>
                        {{ doctorProfile.apcNumber ? doctorProfile.apcNumber : '-' }}
                    </td>
                </tr>
                <tr>
                    <th>APC Document</th>
                    <td>
                        <div v-if="!!apcUpload.docFileNameGUID">
                            <div>
                                <a :href="`${doctorDocumentPath}${apcUpload.docFileNameGUID}`" class="btn btn-primary btn-primary-insv" target="_blank">Download Document</a>
                            </div>
                        </div>
                        <div v-else class="font-italic">Not Uploaded</div>
                    </td>
                </tr>
                <!-- <tr>
                    <th>Borang B Number</th>
                    <td>
                        {{ doctorProfile.borangBNumber }}
                    </td>
                </tr>
                <tr>
                    <th>Borang B Document</th>
                    <td>
                        <div v-if="!!borangBUpload.docFileNameGUID">
                            <div>
                                <a :href="`${doctorDocumentPath}${borangBUpload.docFileNameGUID}`" class="btn btn-primary btn-primary-insv" target="_blank">Download Document</a>
                            </div>
                        </div>
                        <div v-else class="font-italic">None</div>
                    </td>
                </tr> -->
            </table>

            <table class="table table-bordered table-sm">
                <colgroup>
                    <col width="250">
                    <col>
                </colgroup>
                <tr>
                    <th colspan="2" class="text-uppercase">Bank Details</th>
                </tr>
                <tr>
                    <th>Bank Payee Name</th>
                    <td>
                        {{bankAccount.bankAccountPayeeName}}
                    </td>
                </tr>
                <tr>
                    <th>Bank Name</th>
                    <td>
                        {{bankAccount.bankName}}
                    </td>
                </tr>
                <tr>
                    <th>Bank Account Number</th>
                    <td>
                        {{bankAccount.accountNumber}}
                    </td>
                </tr>
            </table>

            <button class="btn btn-primary btn-primary-insv" @click="backToList">Back to List</button>
        </div>
    </div>
</template>

<script>
import identificationTypes from '@/config/identificationTypes';
import {
    apiPath
} from '@/config';
import {
    convertDateToDDMMYYYY
} from '@/utilities';
export default {
    'name': 'DoctorApprovalDetails',
    'computed': {
        doctorId () {
            return this.$route.params.id;
        },
        doctorSpecialties () {
            let list = [];

            this.specialtyList.forEach((s) => {
                if (this.doctorProfile.specialtyIds.includes(s.value)) {
                    list.push(s.text);
                }
            });

            return list.join(', ');
        }
    },
    data () {
        return {
            'userProfile': {
                'name': null,
                'email': null,
                'phoneNo': null,
                'identitifcationType': null,
                'identificationNumber': null,
                'joinedDate': null
            },
            'doctorProfile': {
                'registrationNumber': null,
                'languagesSpeak': null,
                // 'specialtyId': null,
                'specialtyIds': [],
                'affiliation': null,
                'yearsPracticing': null,
                'education': null,
                'apcNumber': null,
                'apcExpiry': null,
                'location': null
                // 'borangBNumber': null
            },
            'profilePhoto': {
                'pictureUrl': ''
            },
            'mmcUpload': {
                'docFileNameGUID': '',
                'docOriFileName': ''
            },
            'apcUpload': {
                'docFileNameGUID': '',
                'docOriFileName': ''
            },
            // 'borangBUpload': {
            //     'docFileNameGUID': '',
            //     'docOriFileName': ''
            // },
            'doctorDocumentPath': `${apiPath}Profile/DoctorDocument?fileName=`,
            'bankAccount': {
                'bankAccountPayeeName': '',
                'bankName': '',
                'accountNumber': ''
            },
            'specialtyList': [],
            'isApproved': false,
            'isReviewed': false,
            'isDisapproved': false
        };
    },
    mounted () {
        this.getDoctorApproval();
        this.retrieveSpecialtyList();
    },
    'methods': {
        getDoctorApproval () {
            this.axios.get('doctor/GetDoctorApproval', {
                'params': {
                    'doctorId': this.doctorId
                }
            }).then(({
                data
            }) => {
                if (data.data) {
                    let profileData = data.data.p;

                    if (profileData) {
                        this.userProfile.name = profileData.f;
                        this.userProfile.email = profileData.e;

                        let idType = identificationTypes.find(i => i.value === profileData.ict);

                        this.userProfile.identitifcationType = idType ? idType.text : '-';
                        this.userProfile.identificationNumber = profileData.ic;
                        this.userProfile.phoneNo = profileData.p;
                        this.userProfile.joinedDate = convertDateToDDMMYYYY(data.data.jd);

                        let doctorProfile = profileData.dp;
                        this.doctorProfile.registrationNumber = doctorProfile.rn;
                        // this.doctorProfile.specialtyId = doctorProfile.si;
                        this.doctorProfile.specialtyIds = doctorProfile.ds.map(ds => ds.si);
                        this.doctorProfile.languagesSpeak = doctorProfile.l;
                        this.doctorProfile.affiliation = doctorProfile.dhca;
                        this.doctorProfile.yearsPracticing = doctorProfile.yp;
                        this.doctorProfile.education = doctorProfile.edu;
                        this.doctorProfile.apcNumber = doctorProfile.apc;
                        // this.doctorProfile.borangBNumber = doctorProfile.bbn;
                        // this.doctorProfile.apcExpiry = convertDateToDDMMYYYY(doctorProfile.apce);
                        this.doctorProfile.location = doctorProfile.loc;

                        this.profilePhoto.pictureUrl = profileData.piu;

                        if (doctorProfile.dmc) {
                            this.mmcUpload.docFileNameGUID = doctorProfile.dmc.fg;
                            this.mmcUpload.docOriFileName = doctorProfile.dmc.fn;
                        }

                        if (doctorProfile.dac) {
                            this.apcUpload.docFileNameGUID = doctorProfile.dac.fg;
                            this.apcUpload.docOriFileName = doctorProfile.dac.fn;
                        }

                        // if (doctorProfile.dbb) {
                        //     this.borangBUpload.docFileNameGUID = doctorProfile.dbb.fg;
                        //     this.borangBUpload.docOriFileName = doctorProfile.dbb.fn;
                        // }

                        this.bankAccount.bankAccountPayeeName = doctorProfile.bap;
                        this.bankAccount.bankName = doctorProfile.bn;
                        this.bankAccount.accountNumber = doctorProfile.ba;

                        this.isApproved = data.data.ia;
                        this.isReviewed = data.data.ir;
                        this.isDisapproved = data.data.id;
                    }
                }
            });
        },
        retrieveSpecialtyList () {
            this.axios.get('/Doctor/GetDoctorSpecialties').then(({
                data
            }) => {
                let list = data.data;

                // this.specialtyList = list.map((i) => {
                //     return {
                //         'value': i.si,
                //         'text': i.sn
                //     };
                // });

                for (let doctorSpecialty of list) {
                    this.specialtyList.push({
                        'value': doctorSpecialty.si,
                        'text': JSON.parse(doctorSpecialty.sn).en
                    });
                }
            });
        },
        updateApproval (isApproved) {
            this.axios.post('doctor/UpdateDoctorApproval', {
                'doctorId': this.doctorId,
                'isApproved': isApproved
            }).then(({
                data
            }) => {
                this.getDoctorApproval();
            });
        },
        backToList () {
            window.history.back();
        }
    }
};
</script>

<style>
    .doctor-profile {
        width: 150px;
        height: 150px;
        border: 1px solid #ccc;
        background-color: #eee;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .doctor-profile .no-photo {
        font-size: 24px;
    }

    .doctor-profile img {
        max-width: 100%;
        max-height: 100%;
    }
</style>
